import { useEffect, useState } from "react";
import { Avatar, Box, CustomPagination, Typography, useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ChannelService from "../../services/message/Channel.service";

import { IPagedList } from "../../commons/interfaces";
import { ChannelPagingType } from "../../constants/enums";
import { IMembers } from "../../containers/channel/useChannel";
import { getNameRoleCommunity } from "../CommunityPost/itemDetailPostComment";

const TableMember = (props: { type: ChannelPagingType; discussionGroupId: string }) => {
    const Strings = useStrings();

    const { onError, onHideLoading, onShowLoading } = useCommonComponentContext();

    const [dataTable, setDataTable] = useState<IPagedList<IMembers>>({
        hasNext: false,
        hasPrevious: false,
        pageSize: 0,
        totalPages: 0,
        totalCount: 0,
        currentPage: 0,
        items: [],
    });

    const getMemberPaged = async (req?: { pageNumber?: number; pageSize?: number }) => {
        try {
            onShowLoading();

            const params: any = {
                type: props.type,
                id: props.discussionGroupId,
                pageSize: req?.pageSize || 10,
                pageNumber: req?.pageNumber || 1,
            };

            const result = await ChannelService.getMemberPaged(params);
            setDataTable(result);

            onHideLoading();
        } catch (error) {
            onHideLoading();
            const err = Helpers.renderExceptionError(error);
            onError(err);
        }
    };

    useEffect(() => {
        !Helpers.isNullOrEmpty(props.discussionGroupId) && getMemberPaged();
    }, [props.discussionGroupId]);

    return (
        <Box>
            <Box display="flex" alignItems="flex-start" flexDirection="row">
                <Box width="50%">
                    <Typography variant="button" color="dark" fontWeight="bold">
                        {Strings.MEMBER.MEMBER_NAME}
                    </Typography>
                </Box>
                <Box width="50%" pl={2}>
                    <Typography variant="button" color="dark" fontWeight="bold">
                        {Strings.MEMBER.ROLE_NAME}
                    </Typography>
                </Box>
            </Box>

            {(dataTable?.items || []).length === 0 ? (
                <Box textAlign="center" px={2}>
                    <Typography variant="button" color="secondary" fontWeight="regular">
                        {Strings.Common.NO_DATA}
                    </Typography>
                </Box>
            ) : (
                (dataTable?.items || []).map((member, index) => (
                    <Box key={index} py={"8px"} display="flex" alignItems="flex-start" flexDirection="row">
                        <Box width="50%" display="flex" alignItems="flex-start">
                            <Avatar
                                src={member?.avatarUrl}
                                style={{ border: "1px #344767 solid" }}
                                text={member?.fullName || member?.userName}
                            />
                            <Box pl={2} display="grid">
                                <Typography
                                    variant="h6"
                                    color="dark"
                                    fontWeight="bold"
                                    sx={{
                                        maxWidth: "200px",
                                        overflow: "hidden",
                                        whiteChannel: "nowrap",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {member?.fullName || "User Name"}
                                </Typography>
                                {member?.userName && (
                                    <Typography
                                        variant="button"
                                        color="secondary"
                                        fontWeight="bold"
                                        sx={{
                                            maxWidth: "200px",
                                            overflow: "hidden",
                                            whiteChannel: "nowrap",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {member?.userName}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                        <Box width="50%" pl={2}>
                            <Typography
                                variant="h6"
                                color="dark"
                                fontWeight="bold"
                                sx={{
                                    maxWidth: "200px",
                                    overflow: "hidden",
                                    whiteChannel: "nowrap",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {getNameRoleCommunity(member?.role)}
                            </Typography>
                        </Box>
                    </Box>
                ))
            )}

            <Box>
                <CustomPagination
                    isList={false}
                    rowsPerPageOptions={[10, 20, 40]}
                    total={dataTable?.totalCount || 0}
                    page={dataTable?.currentPage || 1}
                    pageSize={dataTable?.pageSize || 10}
                    onChangePage={(value) => {
                        getMemberPaged({ pageNumber: value, pageSize: dataTable?.pageSize });
                    }}
                    onChangePageSize={(value) => {
                        getMemberPaged({ pageNumber: dataTable?.currentPage, pageSize: value });
                    }}
                />
            </Box>
        </Box>
    );
};

export default TableMember;
